import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { useLocation } from "wouter";
import { useAuth } from "@/contexts/AuthContext";
import heroBg from "@assets/generated_images/dark_moody_football_stadium_at_night_with_stadium_lights.png";

export function Hero() {
  const [, setLocation] = useLocation();
  const { isAuthenticated } = useAuth();

  const handleViewFreeTips = () => {
    if (isAuthenticated) {
      // Scroll to tips section
      document.getElementById('tips')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Redirect to registration
      setLocation('/register');
    }
  };

  const handleGetStarted = () => {
    if (isAuthenticated) {
      // Scroll to pricing section
      document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Redirect to registration with redirect parameter
      setLocation('/register?redirect=pricing');
    }
  };
  return (
    <div className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-transparent z-10" />
        <div className="absolute inset-0 bg-black/40 z-10" />
        <img 
          src={heroBg} 
          alt="Stadium Background" 
          className="w-full h-full object-cover"
        />
      </div>

      <div className="container relative z-20 px-4 pt-20 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-block px-4 py-1.5 mb-6 rounded-full glass border-primary/20 bg-primary/10">
            <span className="text-primary text-sm font-bold tracking-widest uppercase">
              #1 Football Intelligence Platform
            </span>
          </div>
          
          <h1 className="text-6xl md:text-8xl font-bold mb-6 leading-tight">
            BEAT THE <br />
            <span className="text-gradient-primary">BOOKMAKERS</span>
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10">
            Professional grade football betting tips powered by advanced data analytics and expert insights. Join 50,000+ winners today.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              className="h-14 px-8 text-lg font-bold w-full sm:w-auto"
              onClick={handleGetStarted}
            >
              Get Started Now <ChevronRight className="ml-2 h-5 w-5" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="h-14 px-8 text-lg font-bold w-full sm:w-auto bg-transparent border-white/20 hover:bg-white/5 text-white"
              onClick={handleViewFreeTips}
            >
              View Free Tips
            </Button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
